import { sessionAlive } from "../services/identity-service";
import CONSTANTS from "./constants";

export const getBrowserCDDC = () => {
    const fingerPrintRaw: any = {
        browser: {
            "userAgent": window.navigator.userAgent
        },
        support: {
            "ajax": true, "checkClone": true, "checkOn": true, "cors": true
        },
        computer: {
            "screenWidth": window.innerHeight,
            "screenHeight": window.innerWidth,
            "OS": window.navigator.appVersion,
            "platform": window.navigator.platform
        },
        additional: {}
    }
    const cddc: any = {
        fingerprintHash: "e96dadc9651f5fe8f071110eb174fe8e7a17a9d7a96b3b1980c13e5b4af3a4d7",
        fingerprintRaw: JSON.stringify(fingerPrintRaw)
    };
    return JSON.stringify(cddc);
}

export const setCookie = (key, value) => {
    document.cookie = `${key}=${value}; path=/; Secure`;
}

export const getCookie = (key) => {
    const cookies = document.cookie.split(';');
    const filteredCookie = cookies.find((cookie) => cookie.trim().split('=')[0] === key);
    return filteredCookie?.split('=')[1];
}

export const removeCookies = () => {
    document.cookie.split(";").filter(c => c.includes(CONSTANTS.USER_TOKEN_KEY))
    .forEach(
        (c) => {
            const expireCookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/;Secure");
            document.cookie = expireCookie
    });
}

const checkIfJwtExpiringInXSeconds = (jwtToken, seconds: number = 60) => {
    const payload = jwtToken.split(".")[1];
    const payloadJSON = JSON.parse(atob(payload));
    const expirationTimestamp = payloadJSON.exp * 1000;
    const now = Date.now();

    return (expirationTimestamp - now) < (1000 * seconds);
}

export const isLoginExpiringInXSeconds = (seconds: number = 60) => {
    const authJWT = getCookie(CONSTANTS.USER_TOKEN_KEY)
    // If there's no cookie, login is already "expired"
    if (!authJWT) {
        return true
    }
    return checkIfJwtExpiringInXSeconds(authJWT, seconds)
}

export const isLoginExpired = () => {
    const authJWT = getCookie(CONSTANTS.USER_TOKEN_KEY)
    // If there's no cookie, login is expired
    if (!authJWT) {
        return true
    }
    return checkIfJwtExpiringInXSeconds(authJWT, 0)
}

export const refreshUserSession = async () => {
    if (!isLoginExpired()) {
        const aliveResponse = await sessionAlive()
        if (aliveResponse?.data) {
            const refreshToken = aliveResponse?.data
            setCookie(CONSTANTS.USER_TOKEN_KEY, refreshToken)
        }
    }
}

export const isUserAdmin = (user)=>{
    return user?.user_role === "admin"
}

export const isUserCS = (user)=>{
    return user?.user_role === "credit_solutions"
}

export const isCSCardsUser = (user):boolean=>{
    return user?.user_role === 'cs_cards';
}